import { useState } from "react";
import { CATEGORIES, GUA_FEED, type GuaItem } from "@/mocks/guaData";
import SectionHeading from "./SectionHeading";

function GuaCard({ item }: { item: GuaItem }) {
  const [liked, setLiked] = useState(false);
  const [likes, setLikes] = useState(item.likes);

  const toggleLike = () => {
    setLiked((v) => !v);
    setLikes((n) => (liked ? n - 1 : n + 1));
  };

  return (
    <article className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-0.5 hover:border-primary-200">
      <div className="flex items-center justify-between">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-700">
          {item.emoji} {item.category}
        </span>
        {item.isNew && (
          <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-2 py-0.5 text-[11px] text-background-50">
            <i className="ri-flashlight-fill"></i> 新瓜
          </span>
        )}
      </div>

      <h3 className="mt-3 text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
        {item.title}
      </h3>
      <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{item.summary}</p>

      <div className="mt-3 flex flex-wrap gap-1.5">
        {item.tags.map((t) => (
          <span key={t} className="rounded bg-background-200 px-2 py-0.5 text-[11px] text-foreground-600">
            #{t}
          </span>
        ))}
      </div>

      <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
        <span className="inline-flex items-center gap-1">
          <i className="ri-time-line text-accent-600"></i>
          {item.time}
        </span>
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center gap-1">
            <i className="ri-chat-3-line"></i>
            {item.comments.toLocaleString()}
          </span>
          <button
            onClick={toggleLike}
            aria-label="点赞"
            className={`inline-flex cursor-pointer items-center gap-1 rounded-md px-1.5 py-0.5 transition-colors hover:bg-primary-100 ${
              liked ? "text-primary-600" : ""
            }`}
          >
            <i className={liked ? "ri-heart-fill" : "ri-heart-line"}></i>
            {likes.toLocaleString()}
          </button>
        </div>
      </div>
    </article>
  );
}

export default function GuaTian() {
  const [cat, setCat] = useState<string>("全部");
  const list = cat === "全部" ? GUA_FEED : GUA_FEED.filter((g) => g.category === cat);

  return (
    <section id="guatian" className="bg-background-100/70 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            kicker="瓜田速递"
            title="最新鲜的瓜，趁热看"
            desc="娱乐职场、社会生活的热门事件第一时间上架，新鲜瓜田现场不断刷新。"
          />
          <div
            role="tablist"
            aria-label="分类筛选"
            className="flex flex-wrap gap-1 rounded-full bg-background-200 p-1 w-fit"
          >
            {CATEGORIES.map((c) => (
              <button
                key={c}
                role="tab"
                aria-selected={cat === c}
                onClick={() => setCat(c)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  cat === c
                    ? "bg-background-50 font-medium text-primary-700 shadow-sm"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((item) => (
            <GuaCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}